module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-collect-data/boxoffice-collect-data.component.css
// module id = ./src/app/routes/boxoffice/boxoffice-collect-data/boxoffice-collect-data.component.css
// module chunks = 9